import { render } from "./GalleryManager.vue?vue&type=template&id=6742b178"
import script from "./GalleryManager.vue?vue&type=script&lang=js"
export * from "./GalleryManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__